
export default {
  ngServer: '../',
  // ngServer: 'http://localhost:9000/',

  localPlugins: false,

  server: {}
  /*server: {
    hostname: 'localhost',

    port: 8080,

    secure: false,

    app: '/openspecimen'
  }*/
};
